import { useOutletContext } from "react-router-dom";
import { EventOutletContext } from "../_layout";
import EventOverviewTabContent from "./_components/EventOverviewTabContent";
import EventOverviewSkeleton from "./_components/EventOverviewSkeleton";

export default function EventOverviewPage() {
  const { eventData, eventLoading } = useOutletContext<EventOutletContext>();

  if (eventLoading && !eventData) {
    return <EventOverviewSkeleton />;
  }

  if (!eventData) return null;

  return <EventOverviewTabContent event={eventData} />;
}
